// @flow
import client from '../../client'
import getAuthorizedUserId from '../user/getAuthorizedUserId'
import format from '../../utils/format'

// API Endpoint
export const USER_DELETE_CREDIT_CARD = '/auth/users/{0}/payment-options/{1}/'

/**
 * Delete an user's credit card
 * @param  {Object} data Credit card information
 * @param  {number} data.id Credic card ID
 * @return {Promise|Error} A resolved Promise with a boolean response whether
 *                           the credit card deletion was successful or Rejected with an Error
 */
export const deleteCreditCard = (data: { id: number }): Promise<any> => {
  const userId = getAuthorizedUserId()
  const endpoint = format(USER_DELETE_CREDIT_CARD, userId, data.id)
  return client.delete(endpoint, null).then(() => true)
}

export default deleteCreditCard
